let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cT1z5")).then(() => parcelRequire('hXDVI'));